import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import { Popover, Typography, Paper, InputBase } from "@mui/material";
import { makeStyles } from "@mui/styles";
import SearchIcon from "@mui/icons-material/Search";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useMutation, useQuery } from "react-query";
import fetcher from "../../../../../dataProvider";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    height: "350px",
    width: "450px",
    overflow: "auto",
    background: "#444444",
  },
  column: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "5px",
    rowGap: "10px",
  },
  imgContainer: {
    position: "relative",
    color: "white",
  },
  imgText: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: "3",
    fontSize: "24px",
  },
  img: {
    width: "100%",
    height: "auto",
  },
  gif: {
    width: "100%",
    height: "auto",
    filter: "brightness(80%)",
    cursor: "pointer",
    "&:hover": {
      width: "100.2%",
      filter: "brightness(40%)",
      border: "1.5px solid #dd3f93",
    },
  },
  gifSub: {
    width: "100%",
    height: "auto",
    cursor: "pointer",

    "&:hover": {
      width: "100.2%",
      filter: "brightness(100%)",
      border: "1.5px solid #dd3f93",
    },
  },
}));

const GifCategoryDisplay = ({ classes, data, getByTag }) => {
  return (
    <>
      {data?.map((item, index) => (
        <div
          key={index}
          onClick={() => getByTag(item.searchterm)}
          className={classes.imgContainer}
        >
          <Typography className={classes.imgText} sx={{ p: 2 }}>
            {item.searchterm}
          </Typography>{" "}
          <img alt={item.searchterm} className={classes.gif} src={item.image} />
        </div>
      ))}
    </>
  );
};
const GifDisplay = ({ classes, data, onSelectGif, closeGifPicker }) => {
  return (
    <>
      {data?.map((item, index) => (
        <div key={index} className={classes.imgContainer}>
          <img
            onClick={() => {
              onSelectGif(item.media[0].tinygif.url);
              closeGifPicker();
            }}
            className={classes.gifSub}
            src={item.media[0].tinygif.url}
            alt={"GIF image"}
          />
        </div>
      ))}
    </>
  );
};

const StickerPicker = ({ onSelectGif, disabled }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [gifCategoryEven, setGifCategoryEven] = useState([]);
  const [gifCategoryOdd, setGifCategoryOdd] = useState([]);
  const [gifListEven, setGifListEven] = useState([]);
  const [gifListOdd, setGifListOdd] = useState([]);
  const [isCategories, setIsCategories] = React.useState(true);
  const [title, setTitle] = useState("All");
  const classes = useStyles();
  const { data: gifCategoryData } = useQuery(`gifs/categories`, () =>
    fetcher.get(`/v1/gifs/categories`)
  );
  const { mutate: getGifByTag } = useMutation((tag) =>
    fetcher.get(
      `/v1/gifs/search?tag=${encodeURIComponent(tag)}&limit=100&pos=1`
    )
  );
  const openGifPicker = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };
  const closeGifPicker = () => {
    setAnchorEl(null);
    setTitle("All");
    setOpen(false);
    setIsCategories(true);
  };

  useEffect(() => {
    if (
      gifCategoryData &&
      gifCategoryData.tags &&
      gifCategoryData.tags.length > 0
    ) {
      var _cat = gifCategoryData.tags;
      let evenArray = _cat.filter((a, i) => i % 2);
      let oddArray = _cat.filter((a, i) => !(i % 2));
      setGifCategoryEven(evenArray);
      setGifCategoryOdd(oddArray);
    }
  }, [gifCategoryData]);

  const getByTag = (tag) => {
    setIsCategories(false);
    setTitle(tag.toString());
    getGifByTag(tag, {
      onSuccess: (res) => {
        let evenArray = res.results.filter((a, i) => i % 2);
        let oddArray = res.results.filter((a, i) => !(i % 2));
        setGifListEven(evenArray);
        setGifListOdd(oddArray);
      },
    });
  };

  return (
    <>
      <button
        type="button"
        className="sticker_picker"
        disabled={disabled}
        aria-label="Gif"
        onClick={openGifPicker}
      >
        <img src="/images/gif.svg" width="20" height="20" alt="gif icon" />
      </button>
      <Popover
        id={"gif-popover"}
        open={open}
        anchorEl={anchorEl}
        onClose={closeGifPicker}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Paper
          component="form"
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            background: "white",
            border: "1px solid black",
          }}
        >
          {isCategories ? (
            ""
          ) : (
            <IconButton
              color="inherit"
              aria-label="upload sticker"
              component="span"
              onClick={() => {
                setIsCategories(true);
                setTitle("All");
              }}
            >
              <ArrowBackIcon />
            </IconButton>
          )}
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder={title}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onKeyDown={(e) => {
              if (e.key == "Enter") {
                getByTag(title);
                e.preventDefault();
              }
            }}
          />
          <IconButton
            onClick={(e) => {
              // e.preventDefault();
              console.log("onclick");
              getByTag(title);
            }}
            sx={{ p: "10px" }}
            aria-label="search"
          >
            <SearchIcon />
          </IconButton>
        </Paper>
        {isCategories ? (
          <div className={classes.container}>
            <div className={classes.column}>
              <GifCategoryDisplay
                classes={classes}
                data={gifCategoryEven}
                getByTag={getByTag}
              />
            </div>
            <div className={classes.column}>
              <GifCategoryDisplay
                classes={classes}
                data={gifCategoryOdd}
                getByTag={getByTag}
              />
            </div>
          </div>
        ) : (
          <div className={classes.container}>
            <div className={classes.column}>
              <GifDisplay
                classes={classes}
                data={gifListOdd}
                onSelectGif={onSelectGif}
                closeGifPicker={closeGifPicker}
              />
            </div>
            <div className={classes.column}>
              <GifDisplay
                classes={classes}
                data={gifListEven}
                onSelectGif={onSelectGif}
                closeGifPicker={closeGifPicker}
              />
            </div>
          </div>
        )}
      </Popover>
    </>
  );
};

export default StickerPicker;
